(function () {
  function initSlider(track, prev, next, dotsWrap) {
    var items       = Array.from(track.querySelectorAll('.icons-of-the-house__item'));
    var currentPage = 0;
    var infinite    = track.getAttribute('data-infinite') === 'true';

    function getGap() {
      return parseFloat(getComputedStyle(track).gap) || 0;
    }

    function getVisibleCount() {
      if (!items.length) return 1;
      return Math.max(1, Math.round(track.offsetWidth / (items[0].offsetWidth + getGap())));
    }

    function getPageCount() {
      return Math.ceil(items.length / getVisibleCount());
    }

    function pageScrollTarget(page) {
      var idx       = Math.min(page * getVisibleCount(), items.length - 1);
      var itemRect  = items[idx].getBoundingClientRect();
      var trackRect = track.getBoundingClientRect();
      var target    = track.scrollLeft + (itemRect.left - trackRect.left);
      var maxScroll = track.scrollWidth - track.offsetWidth;
      return Math.max(0, Math.min(target, maxScroll));
    }

    function goToPage(page) {
      var total = getPageCount();
      if (infinite) {
        currentPage = ((page % total) + total) % total;
      } else {
        currentPage = Math.max(0, Math.min(page, total - 1));
      }
      track.scrollTo({ left: pageScrollTarget(currentPage), behavior: 'smooth' });
      updateUI();
    }

    function updateArrows() {
      if (!prev && !next) return;
      var allFit = track.scrollWidth <= track.offsetWidth + 1;
      if (prev) prev.style.visibility = (allFit || (!infinite && currentPage === 0)) ? 'hidden' : 'visible';
      if (next) next.style.visibility = (allFit || (!infinite && currentPage >= getPageCount() - 1)) ? 'hidden' : 'visible';
    }

    function updateDots() {
      if (!dotsWrap) return;
      Array.from(dotsWrap.querySelectorAll('.icons-of-the-house__dot')).forEach(function (d, i) {
        d.classList.toggle('is-active', i === currentPage);
      });
    }

    function updateUI() { updateArrows(); updateDots(); }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var pageCount = getPageCount();
      for (var p = 0; p < pageCount; p++) {
        var btn = document.createElement('button');
        btn.className = 'icons-of-the-house__dot' + (p === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Go to page ' + (p + 1));
        (function (page) {
          btn.addEventListener('click', function () { goToPage(page); });
        }(p));
        dotsWrap.appendChild(btn);
      }
    }

    if (prev) prev.addEventListener('click', function () { goToPage(currentPage - 1); });
    if (next) next.addEventListener('click', function () { goToPage(currentPage + 1); });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var sl    = track.scrollLeft;
        var total = getPageCount();
        var best  = 0, bestDist = Infinity;
        for (var i = 0; i < total; i++) {
          var d = Math.abs(pageScrollTarget(i) - sl);
          if (d < bestDist) { bestDist = d; best = i; }
        }
        if (best !== currentPage) { currentPage = best; updateUI(); }
      }, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      currentPage = 0;
      track.scrollTo({ left: 0, behavior: 'instant' });
      buildDots();
      updateUI();
    });

    requestAnimationFrame(function () { buildDots(); updateUI(); });
  }

  /* Find every slider track on the page and initialise it.
     The section ID is derived from the element's own ID so no Liquid is needed. */
  document.querySelectorAll('[id^="ioth-track-"]').forEach(function (track) {
    var sectionId = track.id.replace('ioth-track-', '');
    var prev      = document.getElementById('ioth-prev-' + sectionId);
    var next      = document.getElementById('ioth-next-' + sectionId);
    var dotsWrap  = document.getElementById('ioth-dots-' + sectionId);
    initSlider(track, prev, next, dotsWrap);
  });
})();
